import React from "react";
import { injectIntl } from "react-intl";
import { withRouter } from 'react-router';
import connect from "react-redux/es/connect/connect";
import { Card, Col, List, Row, Select } from "antd";
import { CircleChartAssets } from "../../dashboard/CircleChart";
import BunkeyAPI from "../../../api/BunkeyAPI";
import "./client-report.css";
import GraphicLine from "../../graphics/GraphicLine";

const { Option } = Select
const DAYS_7 = 7;
const DAYS_30 = 30;
const DAYS_90 = 90;
const DAYS_180 = 180;
const DAYS_365 = 365;

export class ClientReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      folderSpace: 0,
      folderSpaceInBytes: 0,
      totalAssets: 0,
      assetList: [],
      days: DAYS_7,
      data: {
        totalAccess: []
      }
    };
  }

  componentDidMount() {
    this.getSpaceFolder();
    this.getAssetsQuantity();
    this.getRecentReport();
  }

  getSpaceFolder() {
    const {client} = this.props;

    BunkeyAPI({
      url: `/clients/getSpaceFolder`,
      method: 'POST',
      data: {
        client: client._id
      }
    }).then(resp => {
      if (resp && resp.status === 200) {
        this.setState({
          folderSpace: resp.data.size,
          folderSpaceInBytes: resp.data.size_in_bytes
        })
      }
    }).catch(err => {
      console.log('ERR: ', err)
    })
  }

  getAssetsQuantity() {
    const {
      client,
      intl
    } = this.props;

    BunkeyAPI({
      url: `/clients/${client._id}/objects/quantity`,
      method: 'GET'
    }).then(resp => {
      if (resp && resp.status === 200) {
        this.setState({
          assetList: [
            {
              title: intl.formatMessage({id: 'videos'}),
              qty: resp.data['videos'],
              background: '#F8BA0A',
              type: 'video'
            },
            {
              title: intl.formatMessage({id: 'files-audios'}),
              qty: resp.data['audios'],
              background: '#FFAEED',
              type: 'audio'
            },
            {
              title: intl.formatMessage({id: 'images'}),
              qty: resp.data['images'],
              background: '#BED9FA',
              type: 'image'
            },
            {
              title: intl.formatMessage({id: 'files-fonts'}),
              qty: resp.data['fonts'],
              background: '#19D491',
              type: 'font'
            },
            {
              title: intl.formatMessage({id: 'documents'}),
              qty: resp.data['documents'],
              background: '#DEAAD3',
              type: 'document'
            },
            {
              title: intl.formatMessage({id: 'files-others'}),
              qty: resp.data['others'],
              background: '#3AA52B',
              type: 'other'
            },
            {
              title: intl.formatMessage({id: 'bin'}),
              qty: resp.data['recycles'],
              background: '#E0091D',
              type: 'recycle'
            }            
          ],
          totalAssets: resp.data['videos'] + resp.data['audios'] + resp.data['images'] + resp.data['fonts'] + resp.data['documents'] + resp.data['others'] + resp.data['fonts']
        })
      }
    }).catch(err => {
      console.log('ERR: ', err)
    })
  }

  getRecentReport() {
    const {client} = this.props;

    BunkeyAPI({
      url: `/clients/getTypeAndClientRecentReport?idClient=${client._id}`,
      method: 'GET'
    }).then(resp => {
      if (resp && resp.status === 200) {
        this.setState({
          data: resp.data.output[0]
        })
      }
    }).catch(err => {
      console.log('ERR: ', err)
    })
  }

  handleOnChange = value => {
    this.setState({
      days: value
    })
  };

  render() {
    const {assetList, folderSpace, folderSpaceInBytes, totalAssets, days, data} = this.state;
    const {client, intl} = this.props;

    const contractedSpace = client.contractedSpace;

    return (
      <React.Fragment>
        <Row gutter={16} style={{width: '100%'}} className="client-report">
          <Col md={4} xs={24}>
            <CircleChartAssets assetList={assetList}
                               folderSpaceInBytes={folderSpaceInBytes}
                               contractedSpaceInGb={contractedSpace}/>
          </Col>
          <Col md={7} xs={24}>
            <List
              style={{borderRadius: '10px', marginBottom: '30px'}}
              header={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                <Row>
                  <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'total_assets'})}</b></Col>
                  <Col span={8} style={{textAlign: "right"}}><b>{totalAssets}</b></Col>
                </Row>
              </div>}
              footer={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                <Row>
                  <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'stored_weight'})}</b></Col>
                  <Col span={8} style={{textAlign: "right"}}><b>{folderSpace}</b></Col>
                </Row>
              </div>}
              bordered
              dataSource={assetList}
              renderItem={(item) => (
                <List.Item style={{padding: "3px 0px", borderBottom: 0}}>
                  <div className="container">
                    <Row>
                      <Col  span={16} style={{textAlign: "left"}}><span
                        style={{background: item.background}} className="circle"/>{item.title}</Col>
                      <Col span={8} style={{textAlign: "right"}}>{item.qty}</Col>
                    </Row>
                  </div>
                </List.Item>
              )}
            />
          </Col>
          <Col md={13} xs={24}>
            <Card style={{ textAlign: 'center', margin: 0, padding: '0 !important' }} >
              <Select defaultValue={days} onChange={this.hanleOnChange} style={{ width: 120 }}>
                <Option value={DAYS_7}>7 {intl.formatMessage({ id: "days" })}</Option>
                <Option value={DAYS_30}>30 {intl.formatMessage({ id: "days" })}</Option>
                <Option value={DAYS_90}>90 {intl.formatMessage({ id: "days" })}</Option>
                <Option value={DAYS_180}>180 {intl.formatMessage({ id: "days" })}</Option>
                <Option value={DAYS_365}>365 {intl.formatMessage({ id: "days" })}</Option>
              </Select>
              <GraphicLine width={500} height={200} data={data.totalAccess.slice(data.totalAccess.length - days, data.totalAccess.length).map(r => {
                return {
                  "x": r.date,
                  "accesos": r.qty
                }
              })} />
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {}
};
const mapDispatchToProps = {};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientReport)))
